<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse" [fullScreen]="true">
  <p style="color: black"> กำลังโหลดข้อมูล... </p>
</ngx-spinner>
<!-- content -->
<div class="content-wrapper" style="min-height: 307px">

  <div class="card">
    <div class="card-header bg-primary">
      <b>รายการขอเกี๊ยวปี {{isYear[2]}} </b>
      <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="Loadlistaskformoney();"><i class="fas fa-sync"></i>
        </button>
        <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
        </button>
      </div>
    </div>
    <div class="card-body" [formGroup]="adda">

      <!--<div >                    
        <div class="check-control " >
          <div *ngFor="let item of subtype0" >                              
            <div class="form-check form-check-inline">                    
              <label class="form-check-label">
                <input formControlName="t0" value="{{item.l_id}}" class="form-check-input" type="radio" (change)="SubTypeSelectM(item.l_id)" name="t0" id="{{item.l_id}}">
                {{item.doc}}
              </label>
            </div>
          </div>                                    
        </div>
      </div>-->
      <div class="row" [ngSwitch]="edit_st">
        <div class="col-sm-auto" *ngSwitchCase="0">
          <div class="form-row align-items-center">
            <div *ngFor="let item of subtype0">
              <button type="button" [ngClass]="{'btn btn-outline-primary btn-sm' : true }" name="maintype" id="t0"
                [value]="item.id" (click)="SubTypeSelectM(item.l_id)">{{item.doc}}
              </button>
            </div>
            <button type="button" [ngClass]="{'btn btn-outline-danger btn-sm' : true }" name="maintype" id="t0"
              (click)="resetdata()">รีเซ็ตกรอง</button>
          </div>
          <div class="form-row align-items-center">
            <div *ngFor="let item of subtype1">
              <button type="button" [ngClass]="{'btn btn-outline-secondary btn-sm' : true }" name="subtype" id="t1"
                [value]="item.id" (click)="SubTypeSelectS(item.id)">{{item.doc}}
              </button>
            </div>
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="button-row">
            <button mat-raised-button *ngIf="edit_st == 0 " (click)="edit_st = 1">
              ส่งต่อคำขอ <mat-icon style="color: blue;">last_page</mat-icon>
            </button>
            &nbsp; &nbsp;
            <button mat-raised-button *ngIf="edit_st != 0" (click)="saveData(7)">
              <mat-icon style="color: green;"> done </mat-icon><b>บันทึก ส่งต่อ-หัวหน้าแผนกสินเชื่อ</b>
            </button>&nbsp;
            <button mat-raised-button *ngIf="edit_st != 0" (click)="saveData(8)">
              <mat-icon style="color: green;"> done </mat-icon><b>บันทึก ส่งต่อ-ผู้ช่วย ผจก.สินเชื่อ </b>
            </button>&nbsp;
            <button mat-raised-button *ngIf="edit_st != 0" (click)="edit_st = 0">
              <mat-icon style="color: red;"> close </mat-icon>ยกเลิก
            </button>
          </div>
        </div>
        <div *ngSwitchCase="1" class="col-sm-auto">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>ระบุหมายเหตุ</mat-label>
            <textarea matInput style="background: #fff3ad;" [(ngModel)]="dataDoc"
              [ngModelOptions]="{standalone: true}"></textarea>
          </mat-form-field>
        </div>
      </div>

      <mat-form-field appearance="standard">
        <mat-label>ค้นหาชื่อ หรือ เลขที่คำขอ จำนวนเงิน</mat-label>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="รายการที่ต้องการหา" #input>
      </mat-form-field>
      <div class="mat-elevation-z8">
        <table mat-table matSort [dataSource]="listfinancedata" class="mat-elevation-z8">

          <ng-container matColumnDef="no">
            <th mat-header-cell *matHeaderCellDef> ลำดับ </th>
            <td mat-cell *matCellDef="let element; let i = index;">{{i+1}}</td>
          </ng-container>
          <ng-container matColumnDef="ckeackpoint">
            <th mat-header-cell *matHeaderCellDef>
              <a class='far fa-check-square' style='font-size:28;color:rgb(255, 0, 64)' *ngIf="userlv==5"></a>
            </th>
            <td mat-cell *matCellDef="let element;">
              <!--<a class='far fa-check-square' style='font-size:24;color:rgb(0, 26, 255)'
                (click)="getdata(element.docid,element.fmname,element.money_amt,element.comment1)"
                *ngIf="userlv==5"></a>-->
              <section class="example-section">
                <mat-checkbox class="example-margin" [(ngModel)]="element.modify"
                  [ngModelOptions]="{standalone: true}"></mat-checkbox>
              </section>

            </td>
            <!--  
              <mat-checkbox [(ngModel)]="element.completed" ></mat-checkbox>                      
                <mat-checkbox [(ngModel)]="element.completed" (change)="choosedata(element.docid)"></mat-checkbox>
            </td>-->
            <!--<td mat-cell *matCellDef="let element"> 
              <mat-checkbox class="form-control"  formControlName="checkboxControl" [(ngModel)]="element.completed" name="checkbox" (change)="choosedata(element.docid)"></mat-checkbox>
            </td>-->
          </ng-container>

          <ng-container matColumnDef="doc_no">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> เลขที่คำขอ </th>
            <td mat-cell *matCellDef="let element"> {{element.docid}} <button mat-button color="warn"
                [matMenuTriggerFor]="menu" #menuTrigger *ngIf="element.send_back == 'Y'">(ส่งกลับ)</button>
              <mat-menu #menu="matMenu">
                <!--<button mat-menu-item (click)="openDialog()">Open dialog</button>-->
                <label style="text-align:center"> {{element.text_back}} </label>
              </mat-menu>
            </td>
          </ng-container>

          <ng-container matColumnDef="supportter">
            <th mat-header-cell *matHeaderCellDef> <mat-icon>person_add</mat-icon> </th>
            <td mat-cell *matCellDef="let element"> {{element.supcode.trim()}} </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> วันที่ </th>
            <td mat-cell *matCellDef="let element"> {{THtoLocalstring(element.datepost)}} </td>
          </ng-container>
          <ng-container matColumnDef="fmcode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> โควตา </th>
            <td mat-cell *matCellDef="let element"> {{element.fmcode}} </td>
          </ng-container>

          <ng-container matColumnDef="fullname">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ชื่อ-นามสกุล </th>
            <td mat-cell *matCellDef="let element"> {{element.fmname}} </td>
          </ng-container>

          <ng-container matColumnDef="askforunder">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> เรื่องที่ขอ </th>
            <td mat-cell *matCellDef="let element"> {{element.type_money_sub}}-{{element.comment1}} </td>
          </ng-container>

          <!--<ng-container matColumnDef="askfor" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header > เรื่องที่ขอ </th>
            <td mat-cell *matCellDef="let element"> {{element.comment1}} </td>
          </ng-container>-->

          <ng-container matColumnDef="countmoney">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> จำนวนเงิน </th>
            <td mat-cell *matCellDef="let element" [ngClass]="(element.over_limit=='1') ? 'bg-danger' : '' ">
              {{element.money_amt.toLocaleString('ar-TH')}} </td>
          </ng-container>

          <!-- <div [ngClass]="{'message': info.priority<10}">{{info.text}}</div>  -->

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> สถานะ </th>
            <td mat-cell *matCellDef="let element"> {{element.docdesc}} </td>
          </ng-container>

          <ng-container matColumnDef="timeline">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Timeline </th>
            <td mat-cell *matCellDef="let element">
              <button type="button" class="btn btn-primary btn-sm" (click)="Datainmodel(element.firebaseid)"
                data-toggle="modal" data-target="#Timeline">
                <i class="far fa-clock"></i>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="save">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> บันทึก </th>
            <td mat-cell *matCellDef="let element">
              <button type="button" (click)="Datainmodel(element.firebaseid)" class="btn btn-primary btn-sm"
                data-toggle="modal" data-target="#Savestatus">
                <i class="far fa-edit"></i>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="cancle">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ยกเลิก </th>
            <td mat-cell *matCellDef="let element">
              <button type="button" (click)="Cancleid(element.firebaseid)" class="btn btn-danger btn-sm" data-toggle="modal"
                data-target="#Savestatus">
                <i class="far fa-window-close"></i>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displaylist ; sticky: true;"></tr>
          <tr mat-row *matRowDef="let row; columns: displaylist;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 50, 100]" showFirstLastButtons
          aria-label="Select page of periodic elements"></mat-paginator>

      </div>
      <div class="card" *ngIf="dataAr.length > 0">
        <div class="card-header">รายการข้อมูลที่เลือก </div>
        <div class="card-body">
          <form [formGroup]="Actiocmanager">
            <div class="input-group mb-3 col-sm-12">
              <div class="col-sm-8">
                <input type="text" class="form-control" placeholder="ป้อนหมายเหตุ(ถ้ามี)"
                  formControlName="comment_takeasks">
              </div>
              <div class="col-sm-2">
                <button mat-raised-button color="primary" (click)="Takeasks();">รับเรื่อง {{dataAr.length}}
                  รายการ</button>
              </div>
              <div class="col-sm-2">
                <button mat-raised-button color="warn" (click)="cctest();">ยกเลิกการเลือกทั้งหมด</button>
              </div>

            </div>
          </form>
        </div>
        <table class="table table-sm">
          <thead>
            <tr>
              <th style="text-align:center ;">No</th>
              <th>เลขที่คำขอ</th>
              <th>ชื่อชาวไร่</th>
              <th>จำนวนเงิน</th>
              <th>หมายเหตุ</th>
              <th>ยกเลิก</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of dataAr ; index as i">
              <td style="text-align:center;">{{i+1}}</td>
              <td>{{item.docid}}</td>
              <td>{{item.fmname}}</td>
              <td>{{item.money_amt | number}}</td>
              <td>{{item.comment1}}</td>
              <td><button class="btn btn-danger btn-sm" (click)="deletesomevalue(item.docid);">ลบรายการ</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


<!-- Modal Timeline -->
<div class="modal fade" id="Timeline" tabindex="-1" role="dialog" aria-labelledby="TimelineLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" *ngFor="let item of datainmodal">
      <div class="modal-header">
        <h5 class="modal-title" id="TimelineLabel">Timeline เลขที่คำขอ : {{item.docid}} </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="timeline">
          <!-- timeline time label -->
          <div class="time-label">
            <span class="bg-blue">{{THtoLocalstring(item.datepost)}}</span>
          </div>
          <!-- /.timeline-label -->
          <!-- timeline item -->
          <div>
            <i class="fas fa-envelope bg-blue"></i>
            <div class="timeline-item ">
              <span class="time"><i class="fas fa-clock"></i></span>
              <h3 class="timeline-header bg-blue">ผู้จัดการโซน</h3>

              <div class="timeline-body">
                {{item.comment1}} | {{item.money_amt.toLocaleString('ar-TH')}} บาท
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal Timeline -->

<div class="modal fade" id="Savestatus">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="TimelineLabel">บันทึกสถานะ พ.สินเชื่อ </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p *ngFor="let item of datainmodal">เลขที่คำขอ : {{item.docid}} | {{item.fmname}} |
          {{item.comment1}} | {{item.money_amt.toLocaleString('ar-TH')}}
        </p>
        <form [formGroup]="Actiocmanager" *ngFor="let item of datainmodal">
          <div class="input-group mb-3" *ngIf="userlv=='5'">
            <input type="text" class="form-control" placeholder="ป้อนหมายเหตุ(ถ้ามี)" formControlName="comment_takeask">
            <button class="btn btn-outline-dark btn-sm" (click)="Takeask(item.docid)" data-dismiss="modal">
              <i class="far fa-save"></i> รับเรื่อง
            </button>
          </div>
          <div class="input-group mb-3 " *ngIf="userlv=='6'" style="text-align:right">
            <input type="text" class="form-control" placeholder="บันทึกหมายเหตุ(ถ้ามี)" formControlName="comment_save">
          </div>
          <div class="input-group mb-3 " *ngIf="userlv=='6'" style="text-align:right">
            <button class="btn btn-outline-info btn-sm" (click)="Sendforward(item.firebaseid,7)" data-dismiss="modal">
              <i class="fas fa-share-square"></i> ส่งต่อ หัวหน้าแผนกสินเชื่อ
            </button>
          </div>
          <div class="input-group mb-3" *ngIf="userlv=='6'" style="text-align:center">
            <button class="btn btn-outline-secondary btn-sm" (click)="Sendforward(item.firebaseid,8)" data-dismiss="modal">
              <i class="fas fa-share-square"></i> ส่งต่อ ผู้ช่วย ผจก.สินเชื่อ
            </button>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- content -->
<app-footer></app-footer>